import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLasso = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 576,
			cy: 4241.99,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 53.87,
			rx: 352,
			ry: 224,
			transform: "matrix(1.27273 0 0 1.39752 -221.091 -5503.68)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 56.67,
			d: "M90.095 4460.21c-17.262-141.59-127.479 36.27 0 0 26.459-7.53-97.699 159.93 41.81 224",
			transform: "matrix(1.36655 0 0 1.16667 148.069 -4522.36)"
		})
	]
});
export default SvgIconLasso;
